module.exports = __webpack_public_path__ + "media/images/icon_pagetop_arrow_21-12-7444dfe0b5451d053e61fe8e23cc484a.png";